export function formatAddress(
  street1,
  street2,
  city,
  stateAbbreviation,
  postalCode,
): string | null {
  const allEmpty = [
    street1,
    street2,
    city,
    stateAbbreviation,
    postalCode,
  ].every((part) => !part || part.trim() === '')

  if (allEmpty) {
    return null
  }

  const streetLine = [street1, street2]
    .map((part) => part?.trim())
    .filter(Boolean)
    .join(', ')

  const statePostalCode = [stateAbbreviation, postalCode]
    .map((part) => part?.trim())
    .filter(Boolean)
    .join(' ')

  const cityStatePostalCode = [city?.trim(), statePostalCode]
    .filter(Boolean)
    .join(', ')

  return [streetLine, cityStatePostalCode].filter(Boolean).join(', ')
}
